(ns common.schema.display-name
  (:require
   [common.entity :as c-entity]
   [common.schema.entity-type-registry :as reg]))

(defn- fallback-name
  [entity]
  (str (:entity/type entity)
       " FALLBACK "
       (some-> (:db/id entity) str)))

(defn compute
  "Return a user-facing name for the entity or nil.
   Looks up the common entity-type definition for optional display name config."
  [{:keys [entity] :as ctx}]
  (let [entity-type (:entity/type entity)
        entity-type-definition (get reg/entity-types entity-type)
        {:keys [display-name-fn]} entity-type-definition]
    (or
     ;; 1) explicit function in the common definition
     (when (fn? display-name-fn)
       (try (display-name-fn ctx)
            (catch #?(:clj Throwable :cljs :default) _ nil)))

      ;; 2) old display-name
     (c-entity/display-string entity)

      ;; 3) final fallback
     (fallback-name entity))))
